import Config from '../constants/Config';
import Urls from './../api/Urls';
import Golf from '../models/Golf';
import ApiService from './../api/ApiService';

export function getGolfs(params) {
    return new ApiService({
        baseURL: Config.API_GOLF,
        endpoint: Urls.GOLF_LIST,
        params: params,
        parser: (data) => golfDataParser(data, params),
    }).get();
}

export function getGolfDetail(id) {
    return new ApiService({
        baseURL: Config.API_GOLF,
        endpoint: Urls.GOLF_DETAIL,
        endpointParams: { id },
        parser: (data) => new Golf(data.data || data),
    }).get();
}

export function updateGolfDetail(golf) {
    return new ApiService({
        baseURL: Config.API_GOLF,
        endpoint: Urls.GOLF_DETAIL_UPDATE,
        endpointParams: { id: golf.id },
        parser: (data) => new Golf(data.data || data),
    }).put({
        name: golf.name,
        code: golf.code,
        hotline: golf.hotline,
        email: golf.email,
        website: golf.website,
        shortDescription: golf.shortDescription,
        description: golf.description,
        address: golf.address,
        googleMapUrl: golf.googleMapUrl,
        active: golf.active,
        images: golf.media ? golf.media.map(item => item.url) : [],
        locationId: golf.locationId,
        supportPayLater: golf.supportPayLater,
    });
}

export function createGolfTranslate(golf, language) {
    return new ApiService({
        baseURL: Config.API_GOLF,
        endpoint: Urls.GOLF_TRANSLATE_CREATE,
        parser: (data) => data.data
    }).post({
        id: golf.translate.id,
        golfId: golf.id,
        name: golf.name,
        code: golf.code,
        shortDescription: golf.shortDescription,
        description: golf.description,
        address: golf.address,
        languageCode: language,
    });
}

export function updateGolfTranslate(golf, language) {
    return new ApiService({
        baseURL: Config.API_GOLF,
        endpoint: Urls.GOLF_TRANSLATE_UPDATE,
        endpointParams: { id: golf.id },
        parser: (data) => data.data
    }).put({
        name: golf.name,
        shortDescription: golf.shortDescription,
        description: golf.description,
        address: golf.address,
        website: golf.website,
        languageCode: language,
    });
}

export function deleteGolfTranslate(golf, refreshParams) {
    return new ApiService({
        baseURL: Config.API_GOLF,
        endpoint: Urls.GOLF_TRANSLATE_DELETE,
        endpointParams: refreshParams,
        parser: (data) => data.data
    }).delete();
}

export function updateGolfOrder(data) {
    return new ApiService({
        baseURL: Config.API_GOLF,
        endpoint: Urls.GOLF_UPDATE_ORDER,
        parser: (data) => data,
    }).put(data);
}

export function syncAllGolf() {
    return new ApiService({
        baseURL: Config.API_GOLF,
        endpoint: Urls.RATE_SYNC_ALL_GOLF,
        // headers: headersRate
    }).post({});
}

const golfDataParser = (data, params) => {
    return {
        result: (data.data.items || []).map(item => new Golf(item)),
        pageNumber: data.data.pageNumber,
        pageSize: params.pageSize || 10,
        totalCount: data.data.totalCount,
        totalPage: data.data.totalPages
    };
}